import api from './api';

export const promotionGroups = {
  getAll: () => api.get('/promotion-groups', { responseType: 'json' }),
  create: (data) => api.post('/promotion-groups', data),
  update: (id, data) => {
    if (data instanceof FormData) {
      data.append('_method', 'PUT');
      return api.post(`/promotion-groups/${id}`, data);
    }

    return api.put(`/promotion-groups/${id}`, data);
  },
  delete: (id) => api.delete(`/promotion-groups/${id}`),
  // Additional methods (e.g., fetch single group) can be added as needed
};
